const translations = {
    all: 'All',
    grounded: 'Grounded'
};

export default translations;
